import {
  GetTeamsBySalesforceAccountIdRequest,
  GetTeamsBySalesforceAccountIdResponse,
} from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const getTeamsBySalesforceAccountId = (
  req: Partial<GetTeamsBySalesforceAccountIdRequest>
): Promise<GetTeamsBySalesforceAccountIdResponse> =>
  request({
    url: '/service/userv2service/GetTeamsBySalesforceAccountId',
    body: req,
  }).then((r) => r.body);
